import RoleDisplay from "./frontend/roleDisplay";

export const RoleCodes = {
  SystemAdmin: "SYS-ADM",
  TenantAdmin: "TEN-ADM",
  TenantLogisticsOperator: "TEN-LOG-OPR",
  SiteAdmin: "SIT-ADM",
  SiteLogisticsOperator: "SIT-LOG-OPR",
  SupplierLogisticsOperator: "SPL-LOG-OPR",
} as const;

export const RoleDescriptions: RoleDisplay[] = [
  { code: "SYS-ADM", displayName: "System Admin" },
  { code: "TEN-ADM", displayName: "Tenant Admin" },
  { code: "TEN-LOG-OPR", displayName: "Tenant Logistics Operator" },
  { code: "SIT-ADM", displayName: "Site Admin" },
  { code: "SIT-LOG-OPR", displayName: "Site Logistics Operator" },
  { code: "SPL-LOG-OPR", displayName: "Supplier Logistics Operator" },
];
